import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { UserService } from '@/app/services/user.service';
import { ProjectStageApprover } from '@/app/interfaces/project-stage-approver.interface';
import { User } from '@/app/interfaces/user.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-project-stage-approval',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './project-stage-approval.component.html',
  styleUrls: ['./project-stage-approval.component.css']
})
export class ProjectStageApprovalComponent implements OnInit {
  approvals: ProjectStageApprover[] = [];
  currentUser: User | null = null;

  // TODO: create organization interface
  currentOrganization: any = null;
  // TODO: create project interface
  projectId = 0;


  isApprover = false;
  // TODO: these needs to be from be
  statusOptions = [
    { key: 'pending', name: 'Pending' },
    { key: 'in_progress', name: 'In Progress' },
    { key: 'on_hold', name: 'On Hold' },
    { key: 'other', name: 'Other' },
    { key: 'approved', name: 'Approved' },
    { key: 'rejected', name: 'Rejected' }
  ];
  loading = false;
  comments = '';

  constructor(
    private projectService: ProjectsService,
    private userService: UserService
  ) { }

  ngOnInit() {
    
    const userString = localStorage.getItem('User');
    if (userString) {
      this.currentUser = userString ? JSON.parse(userString) : null;
    }

    const organization = localStorage.getItem('org_info');
    if (organization) {
      this.currentOrganization = organization ? JSON.parse(organization) : null;
    }

    const projectId = localStorage.getItem('projectId');
    if (projectId) {
      this.projectId = projectId ? JSON.parse(projectId) : null;
    }

    const stageNumber = this.projectService.getCurrentStageNumber();

    if(this.projectId && stageNumber) {
      
      this.loadApprovals(this.projectId, stageNumber);
    }
  }

  loadApprovals(projectId: number, stageNumber: number) {
    this.loading = true;
    // TODO: this needs to be dynamic
    this.projectService.getProjectStageApprovals(projectId, stageNumber)
      .subscribe({
        next: (response) => {
          if (response.meta.success) {
            this.approvals = response.data;
          }
        },
        error: (error) => {
          console.error('Error loading approvals:', error);
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  updateStatus(newStatus: Event, approver: ProjectStageApprover) {
    const statusValue = (newStatus.target as HTMLSelectElement).value;
    
    // if user is available and is also an approves
    if (!this.projectId || !this.currentUser || approver.user_id !== this.currentUser.id) return;

    this.projectService.updateApprovalStatus(
        this.projectId,
        approver.user_id,
        statusValue,
        this.comments
    ).subscribe({
        next: (response) => {
            if (response.meta.success) {
              approver.status = statusValue;
            }
        },
        error: (error) => {
            console.error('Error updating status:', error);
        }
    });
  }
}